/**
 * Formatação e visibilidade pública do CRM do médico (cards/listagens de paciente).
 */

const LEGACY_PLACEHOLDER_CRM = new Set(['pendente', 'pending', 'n/a', 'na']);
const LEGACY_PLACEHOLDER_UF = new Set(['UF', 'XX']);

export function formatDoctorCrmDisplay(
  crm?: string | null,
  crmState?: string | null,
): string {
  const number = String(crm || '').trim();
  const state = String(crmState || '').trim().toUpperCase();
  if (!number && !state) return '—';
  if (!state) return number;
  if (!number) return state;
  return `${number}/${state}`;
}

export function hasPublicDoctorCrm(
  crm?: string | null,
  crmState?: string | null,
): boolean {
  const number = String(crm || '').trim();
  const state = String(crmState || '').trim().toUpperCase();
  if (!number || !state) return false;
  if (LEGACY_PLACEHOLDER_CRM.has(number.toLowerCase())) return false;
  if (LEGACY_PLACEHOLDER_UF.has(state)) return false;
  return true;
}

/** Rótulo para cards de busca: `CRM: 123456/SP` ou null quando ausente. */
export function getDoctorCrmCardLabel(
  crm?: string | null,
  crmState?: string | null,
): string | null {
  if (!hasPublicDoctorCrm(crm, crmState)) return null;
  return `CRM: ${formatDoctorCrmDisplay(crm, crmState)}`;
}
